import gql from "graphql-tag";

export const actualizarProductoDetalleGql = gql`
    mutation actualizarProductoDetalle($codigoProducto: String!, $codigoVersion: String!, $codigoPresentacion: String!, $urlInstalador: String) {
        actualizarProductoDetalle(
            codigoProducto: $codigoProducto
            codigoVersion: $codigoVersion
            codigoPresentacion: $codigoPresentacion
            urlInstalador: $urlInstalador
        ) {
            codigoProducto
        }
    }
`;

export const getProductoDetalleGql = gql`
    query productoDetalles {
        productoDetalles {
            codigoProducto
            codigoVersion
            codigoPresentacion
            producto {
            denominacion
            }
            version {
            denominacion
            }
            presentacion {
            denominacion
            }
            idProdVerPres
            shopCodProds{
            shopCodProd
            idProdVerPres
            }
            urlInstalador
        }
    }
`;

export const agregarProductoDetalleGql = gql`
    mutation agregarProductoDetalle($codigoProducto: String!, $codigoVersion: String!, $codigoPresentacion: String!, $urlInstalador: String!) {
        agregarProductoDetalle(
            codigoProducto: $codigoProducto
            codigoVersion: $codigoVersion
            codigoPresentacion: $codigoPresentacion
            urlInstalador: $urlInstalador
        ) {
            codigoProducto
        }
    }
`;

export const eliminarProductoDetalleGql = gql`
    mutation eliminarProductoDetalle($codigoProducto: String!, $codigoVersion: String!, $codigoPresentacion: String!) {
        eliminarProductoDetalle(
            codigoProducto: $codigoProducto
            codigoVersion: $codigoVersion
            codigoPresentacion: $codigoPresentacion
        ) {
            codigoProducto
        }
    }
`;